import axios from "./AxiosService";

export function getVirtualLucyUrl(membershipNumber) {
  return axios
    .get("hbs/virtuallucy", {
      params: {
        membershipNumber: membershipNumber
      }
    })
    .then(response => response)
    .catch(error => error);
}

export function SendPolicyNumberToHBS(membershipNumber) {
  return axios
    .get(
      "hbs/SendPolicyNumberToHBS",
      {
        params: {
          membershipNumber: membershipNumber
        }
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
    .then(response => {
      return response;
    });
}
